export default "__VITE_ASSET__DtEW1cRR__"